import Text from "ab-text";
import ParagraphText from "ab-paragraph-text";

import "./ab-metodologia.scss";

const Metodologia = ({ cards, title, text }) => {
  return (
    <div className="ab-metodologia">
      <div className="row">
        <Text element="h2">{title}</Text>

        <ParagraphText content={text} />
      </div>

      <div className="metodologias">
        {cards ? (
          cards.map((itm) => (
            <div className="metodologia-card">
              <img src={itm.image.mediaItemUrl} alt={itm.titulo} />
              <div>
                <Text element="h3">{itm.titulo}</Text>
                <p>
                  <ol>
                    {itm.contenido.map((txt) => (
                      <li>{txt.text}</li>
                    ))}
                  </ol>
                </p>
              </div>
            </div>
          ))
        ) : (
          <>
            {" "}
            <div className="metodologia-card">
              <img src="/images/1-clima.png" alt="Clima" />
              <div>
                <Text element="h3">1. Clima</Text>
                <p>
                  <ol>
                    <li>1.1. Climatología</li>
                    <li>1.2. Tipos de climas</li>
                    <li>1.3. Factores geográficos</li>
                    <li>1.4. Factores meteorológicos</li>
                    <li>1.5. Integral térmica</li>
                    <li>1.6. Cambio climático</li>
                    <li>1.7. Cata de climas</li>
                  </ol>
                </p>
              </div>
            </div>
            <div className="metodologia-card">
              <img src="/images/2-suelo.png" alt="Suelo" />
              <div>
                <Text element="h3">2. Suelo</Text>
                <p>
                  <ol>
                    <li>2.1. Edafología y formación de los suelos</li>
                    <li>2.2. Partes de los Suelos:</li>
                    <li>2.2.1. Granulometría y textura</li>
                    <li>2.2.2. Composición química</li>
                    <li>2.3. El agua en el suelo</li>
                    <li>2.4. Suelos y vinos con nombre propio</li>
                    <li>2.5. Cata de suelos</li>
                  </ol>
                </p>
              </div>
            </div>
            <div className="metodologia-card">
              <img src="/images/3-variedad.png" alt="Variedad" />
              <div>
                <Text element="h3">3. Variedad</Text>
                <p>
                  <ol>
                    <li>3.1. Origen de las variedades actuales</li>
                    <li>3.2. Genotipo y Fenotipo</li>
                    <li>3.3. Evolución de las variedades, los híbridos</li>
                    <li>3.4. Variedades autóctonas</li>
                    <li>3.5. Ciclo Vegetativo y Calentamiento Global</li>
                    <li>3.6. Cata de variedades</li>
                  </ol>
                </p>
              </div>
            </div>
            <div className="metodologia-card">
              <img src="/images/4-factor-humano.png" alt="Factor Humano" />
              <div>
                <Text element="h3">4. Factor humano</Text>
                <p>
                  <ol>
                    <li> 4.1. Factores</li>
                    <li>4.2. Intenciones</li>
                    <li>4.3. Condicionantes</li>
                    <li>4.4. Ventajas y Limitaciones</li>
                    <li>4.5. Decisiones</li>
                    <li>4.6. Tendencias</li>
                    <li>4.7. Cata de factor humano</li>
                  </ol>
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Metodologia;
